import React, { useCallback, useState } from "react";

import { type TExpert } from "~/api";
import { RemoteLogErrorBoundary } from "~/components/common/remote-log-error-boundary";
import { useIntlDocumentTitle } from "~/hooks/use-document-title";

import { CabinetWidget } from "./cabinet-widget";
import { ExpertsList } from "./experts-list";

export default function MeetingsPage() {
  useIntlDocumentTitle("meetings.title");

  const [selectedExpert, setSelectedExpert] = useState<TExpert | null>(null);
  const goBack = useCallback(() => setSelectedExpert(null), []);

  // TODO: use routing here also

  return (
    <RemoteLogErrorBoundary component="meetings-page">
      {selectedExpert ? null : <ExpertsList onExpertClick={setSelectedExpert} />}
      {selectedExpert ? <CabinetWidget expert={selectedExpert} onBackClick={goBack} /> : null}
    </RemoteLogErrorBoundary>
  );
}
